import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { icoLinkExternalDuo } from '../icons';
import { IconsModule } from '../icons/icons.module';
import { TooltipModule } from '../tooltip';
import { ExternalLinkDirective } from './external-link.directive';
import { ExternalLinkOnHoverComponent } from './external-link/external-link-on-hover.component';
import { LinkComponent } from './link/link.component';

@NgModule({
  declarations: [ExternalLinkOnHoverComponent, ExternalLinkDirective, LinkComponent],
  imports: [CommonModule, IconsModule.withIcons(icoLinkExternalDuo), TooltipModule],
  exports: [ExternalLinkOnHoverComponent, ExternalLinkDirective, LinkComponent]
})
export class LinkModule {}
